import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Login from './components/Login';
import Signup from './components/Signup';
import Students from './components/Students';
import StudentDetails from './components/StudentDetails';
import EditStudent from './components/EditStudent';
import AddAssignment from './components/AddAssignment';
import AssignmentDetail from './components/AssignmentDetail';
import Notes from './components/Notes';
import StudentsRequest from './components/StudentRequests';
import Calendar from './components/Calender';
import UnderProgress from './components/UnderProgress';
import UploadPdfAssignment from './components/UploadPdfAssignment';
import MakeFromBook from './components/MakeFromBook';
import ChooseFromBook from './components/ChooseFromBook';
import AssignmentDescription from './components/AssignmentDescription';
import AssignmentSummary from './components/AssignmentSummary';
import NewDoc from './components/NewDoc'; 
import ChitChat from './components/ChitChat';
import Post from './components/Post';
import Books from './components/Books';
import CreateAssignment from './components/CreateAssignment';
import Digitise from './components/Digitise';
import CreateWithAI from './components/CreateWithAI';
import AiGeneratedAssignment from './components/AiGeneratedAssignment';
import CreateExam from './components/CreateExam';
import ExamDescription from './components/ExamDescription';
import AddExam from './components/AddExam';
import UploadExamPdf from './components/UploadExamPdf';
import ProcessExamPdf from './components/ProcessExamPdf'
import ExamSummary from './components/ExamSummary';
import CreateExamFromSyllabus from './components/CreateExamFromSyllabus';
import SelectExamFromPdf from './components/SelectExamFromPdf';
import MakeExamWithAi from './components/MakeExamWithAi';
import AiGeneratedExam from './components/AiGeneratedExam';
import ELearning from './components/eLearning';
import EvaluateAssignmentThroughAi from './components/EvaluateAssignmentThroughAi';
import ViewStudentResponseForAssignment from './components/ViewStudentResponseForAssignment';
import ExamDetails from './components/ExamDetails';
import EvaluateExamThroughAi from './components/EvaluateExamThroughAi';
import ELearningCourseEdit from './components/eLearningCourseEdit';
import LandingPage from './components/LandingPage';
import ResetPassword from './components/ResetPassword';
import {ClassSubjectProvider}  from './contexts/ClassSubjectContext';
import StudentRequests from './components/StudentRequests';
import ExamInfo from './components/ExamInfo';
import { ExamTemplateProvider } from './contexts/ExamTemplateContext';
//import ViewStudentResponseForAssignment from './components/ViewResponseForAssignment';
import ViewStudentResponseForExam from './components/ViewResponseForExam';
import BookDemoPage from './components/bookDemo';
import Dashboard from './components/Profile';
import CreateAssignmentManually from './components/createAssignmentManually';
import ViewCreatedAssignment from './components/viewCreatedAssignment';
import EditCreateAssignment from './components/editCreatedAssignment';
import StudyBuddy from './components/StudyBuddy';
import CreateQuiz from './components/CreateQuiz';
import QuizCreationForm from './components/QuizDescription';
import EditCreatedQuiz from './components/editCreatedQuiz';
import QuizDetails from './components/QuizDetails';
import TeacherQuizResponseView from './components/ViewResponseForQuiz';
import StudentPerformance from './components/StudentPerformance';
import EditTeacherProfile from './components/EditTeacherProfile';
import TeacherDashboard from './components/Dashboard';
import DigitiseNotes from './components/DigitiseNotes';
import NewLandingPage from './components/NewLandingPage';
import MockTestCreator from './components/mockTestCreator';
import AddQuestion from './components/AddQuestionInQuestionbank';
import QuestionBankApp from './components/AddQuestionQuestionbankUploadandEditor';
import AddQuestionQuestionbankUploadandEditor from './components/AddQuestionQuestionbankUploadandEditor';
function App() {
  return (
    <ClassSubjectProvider>
      <ExamTemplateProvider>
    <Router>
      <Routes>
      <Route path="logout" element={<NewLandingPage />} />
      
      <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<NewLandingPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/bookAdemo" element={<BookDemoPage />} />
        <Route path="/" element={<Layout />}>
         <Route path='/Profile' element={<Dashboard />} />
         <Route path='/dashboard' element={<TeacherDashboard />} />
          <Route path="students" element={<Students />} />
          <Route path="digitiseNotes" element={<DigitiseNotes />} />
        
          <Route path="edit-student/:id" element={<EditStudent />} />
          <Route path="/studentrequest" element={<StudentRequests />} />
          <Route path="assignments">
            <Route index element={<CreateAssignment />} />
            <Route path='add' element={<AddAssignment/>}/>
            <Route path="new" element={<AddAssignment />} />
            <Route path="upload-pdf" element={<UploadPdfAssignment />} />
            <Route path="upload-pdf/digitise" element={<Digitise />} />
            <Route path="make-from-book" element={<MakeFromBook />} />
            <Route path="choose-from-book/:bookId" element={<ChooseFromBook />} />
            <Route path="description" element={<AssignmentDescription />} />
            <Route path="ai" element={<UnderProgress />} />
          </Route>
          <Route path="assignment/responses/:assignment_id" element={<AssignmentDetail />} />
          <Route path="assignment/detail/:id/evaluate" element={<EvaluateAssignmentThroughAi />} />
          <Route path="assignment/detail/:id/viewResponse" element={<ViewStudentResponseForAssignment />} />
          <Route path="elearning" element={<ELearning />} />
         
          <Route path="/eLearning/course/:courseId" element={<ELearningCourseEdit />} />
          <Route path="assignments/assignment-summary" element={<AssignmentSummary />} />
          <Route path="assignments/createAssignmet" element={<CreateWithAI />} />
          <Route path="assignments/createWithAI/AiGeneratedAssignment" element={<AiGeneratedAssignment />} />
          <Route path="assignments/createWithAI/createManually" element={<CreateAssignmentManually />} />
          <Route path="assignment/view/:assignmentId" element={<ViewCreatedAssignment />} />
          <Route path="/assignment/edit/:assignmentId" element={<EditCreateAssignment />} />

          <Route path="notes" element={<Notes />} />
          <Route path="questionBankUpload" element={<AddQuestionQuestionbankUploadandEditor />} />
          <Route path="questionBankCreator" element={<MockTestCreator />} />
          <Route path="addQuestionInBank" element={<AddQuestion />} />
          <Route path="new-doc" element={<NewDoc />} />
          <Route path="Announcements" element={<Post />} />
          <Route path="exams" element={<CreateExam/>}>
            <Route index element={<UnderProgress />} />
            <Route path="new" element={<UnderProgress />} />
            <Route path="results" element={<UnderProgress />} />
            <Route path="ai" element={<UnderProgress />} />
            <Route path="evaluate" element={<UnderProgress />} />
          </Route>
          <Route path="exams" element={<ExamInfo/>}/>
          <Route path="exams/description" element={<ExamDescription/>}/>
          <Route path="/exams/exam-summary" element={<ExamSummary/>}/>
          <Route path="/exams/create-from-syllabus" element={<CreateExamFromSyllabus/>}/>
          <Route path="exams/add" element={<AddExam/>}/>
          <Route path="/exams/upload-exam" element={<UploadExamPdf/>}/>
          <Route path="/exams/create-from-syllabus/pdf-list" element={<SelectExamFromPdf/>}/>
          <Route path="/exams/create-with-ai" element={<MakeExamWithAi/>}/>
          <Route path="/exams/createWithAI/AiGeneratedExam" element={<AiGeneratedExam/>}/>
          <Route path="/exams/process" element={<ProcessExamPdf/>}/>
          <Route path="/exam/details/:id" element={<ExamDetails />} />
          <Route path="/exam/details/:id/evaluate/:studentId" element={<EvaluateExamThroughAi />} />
          <Route path="library" element={<Books />} />
          <Route path="uploads" element={<StudentsRequest />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="settings" element={<UnderProgress />} />
          <Route path="assignment/detail/:id/viewResponse" element={<ViewStudentResponseForAssignment />} />
          <Route path="/exam/submission/:examId/:submissionId" element={<ViewStudentResponseForExam />} />
          <Route path="/exam/evaluate/:examId/:submissionId" element={<EvaluateExamThroughAi />} />
          <Route path="communication" element={<ChitChat />} />
          <Route path="quiz" element={<CreateQuiz />} />
          <Route path="/quizzes/description" element={<QuizCreationForm />} />
          <Route path="/quiz/edit/:quizId" element={<EditCreatedQuiz />} />
          <Route path="/books/studybuddy/:bookId" element={<StudyBuddy />} />
          <Route path="quiz/responses/:quiz_id" element={<QuizDetails />} />
          <Route path="quiz/detail/:id/viewResponse" element={<TeacherQuizResponseView />} />
          <Route path="/students/details/:id" element={<StudentPerformance />} />
          <Route path="/teacher/profile-edit" element={<EditTeacherProfile />} />
          <Route path="*" element={<UnderProgress />} />
        </Route>
      </Routes>
    </Router>
    </ExamTemplateProvider>
    </ClassSubjectProvider>
  );
}

export default App;